import { FC } from 'react';

import StepHeader from '@components/quiz/shared/StepHeader';

const CELEBRATION_EMOJI = '🎉';

/**
 * The post-checkout celebration header, styled with the shared funnel
 * StepHeader so the welcome page reads as the funnel's final step.
 */
const WelcomeHero: FC = () => (
  <div className="pt-10">
    <p aria-hidden="true" className="mb-4 text-center text-5xl">
      {CELEBRATION_EMOJI}
    </p>
    <StepHeader
      eyebrow="You're in"
      heading="Activate your Mini-League Promise."
      subtext="Your membership is live. Here's how to get the most out of it from day one."
    />
  </div>
);

export default WelcomeHero;
